import { StepConfig } from '../../../models';
import { StepContainer } from '../StepContainer/StepContainer';

export interface ConfigTreeNode {
  /**
   * the StepConfig for the tree node.
   */
  config: StepConfig;

  /**
   * parent represents the parent node of this node
   * when null, this node is the root node
   */
  parent?: ConfigTreeNode;

  /**
   * the instances of the steps that are using the config of this node
   */
  stepInstances: StepNode[];
}

export interface StepNode {
  parent?: StepNode;
  container: StepContainer;
}

export interface StepState {
  configs: Map<string, ConfigTreeNode>;
  stepNodes: Map<string, StepNode>;
}
